import { render, staticRenderFns } from "./LProjectObjectQuestion.vue?vue&type=template&id=31ef5879&scoped=true&"
import script from "./LProjectObjectQuestion.vue?vue&type=script&lang=js&"
export * from "./LProjectObjectQuestion.vue?vue&type=script&lang=js&"
import style0 from "./LProjectObjectQuestion.vue?vue&type=style&index=0&id=31ef5879&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ef5879",
  null
  
)

export default component.exports